import React from 'react';
import { ShowdownBox } from '../element';
import MarkdownView from 'react-showdown';
import { replaceMarkdownLink } from '../../utils/utils';

export default function ShowMarkdown(props) {
  const markdownString = replaceMarkdownLink(props.contentString);
  return (
    <ShowdownBox>
      <MarkdownView markdown={markdownString} options={{ tables: true }} />
    </ShowdownBox>
  );
}
